// Groei (module Gezondheid) en School (0032_groei_school, golf 3; docs/DESIGN.md §8.GR en §8.SC).
// Toon: je-vorm, korte zinnen, geen oordeel over een kind (golf 19: ook geen "binnen de lijnen";
// alleen de lijnen, een neutrale legenda en de zin `chart.info`).
// De toestemmingstekst van Groei hoort bij GROWTH_CONSENT_VERSION en GROWTH_CONSENT_TEXT_HASHES
// (packages/domain/src/growth/growth.ts). Wijzig je `consent.parental`, `consent.self` of
// `consent.extension`, dan een nieuwe versie met een nieuwe hash (de test in apps/api herberekent hem).
export const appGrowthNl = {
    title: 'Groei',
    intro: 'Lengte en gewicht van jullie kinderen, rustig in een groeicurve. Alleen ouders zien dit. Niet op de tablet, tenzij een ouder dat zelf per tablet uitdrukkelijk bevestigt; dat kan altijd weer worden weggehaald.',
    tab: 'Groei',
    empty: 'Nog geen metingen. Meet eens rustig, bijvoorbeeld na het consultatiebureau of de JGZ.',
    measurements: '{count} metingen',
    measurementsOne: '1 meting',
    lastOn: 'Laatst gemeten op {date}',
    open: 'Groei van {name}',
    noConsentYet: 'Nog niet aangezet',
    noMeasurements: 'Nog geen metingen',
    consent: {
        /** Moet gelijk zijn aan GROWTH_CONSENT_VERSION (packages/domain/src/growth/growth.ts). */
        version: '2026-10-08.1',
        title: 'Groei bijhouden voor {name}?',
        /** Eén punt per regel (\n): de UI toont een korte lijst. */
        parental: {
            text: 'Lengte en gewicht zijn gezondheidsgegevens. We bewaren ze alleen om de groei van {name} in een grafiek te laten zien.\nKies je een referentiegroep voor de groeicurve (kinderen van Turkse, Marokkaanse of Hindostaanse (Surinaamse) herkomst in Nederland), dan bewaren we die keuze ook. Die zegt iets over afkomst.\nIs {name} te vroeg geboren, dan kun je de zwangerschapsduur bij de geboorte invullen. Ook dat is een gezondheidsgegeven.\nAlleen de ouders in dit gezin zien het. Nooit voor kinderen en nooit voor gekoppelde familie. Niet op de tablet, tenzij een ouder dat zelf per tablet uitdrukkelijk bevestigt; dat kan altijd weer worden weggehaald.\nJe kunt alles downloaden. Intrekken wist alle metingen en keuzes van {name} direct; uit back-ups verdwijnt het binnen 90 dagen.\nDe lijnen zijn een hulpmiddel, geen oordeel of diagnose. Twijfel je, vraag het consultatiebureau of de JGZ.\nAMUMIN B.V. is verantwoordelijk voor deze gegevens. Je rechten staan in de privacyverklaring.',
            check: 'Ik ben ouder van {name} ({name} is jonger dan 16) en geef toestemming om de lengte, het gewicht en de keuzes voor de groeicurve van {name} bij te houden.',
        },
        self: {
            text: 'Lengte en gewicht zijn gezondheidsgegevens. We bewaren ze alleen om jouw groei in een grafiek te laten zien.\nWordt er voor jouw groeicurve een referentiegroep gekozen (bijvoorbeeld Turkse, Marokkaanse of Hindostaanse (Surinaamse) herkomst in Nederland), dan bewaren we die keuze ook. Die zegt iets over afkomst. Hetzelfde geldt voor de zwangerschapsduur bij je geboorte als je te vroeg geboren bent: dat is een gezondheidsgegeven.\nAlleen de ouders in dit gezin zien het (dus ook de andere ouder). Nooit voor kinderen en nooit voor gekoppelde familie. Niet op de tablet, tenzij een ouder dat zelf per tablet uitdrukkelijk bevestigt; dat kan altijd weer worden weggehaald.\nJe kunt alles downloaden. Intrekken wist al je metingen en keuzes direct; uit back-ups verdwijnt het binnen 90 dagen.\nAMUMIN B.V. is verantwoordelijk voor deze gegevens. Je rechten staan in de privacyverklaring.',
            check: 'Ik geef toestemming om mijn eigen lengte, gewicht en keuzes voor de groeicurve bij te houden.',
        },
        /**
         * Aanvulling (0051, tekst 2026-09-28.1): gevraagd op het moment dat een ouder een keuze maakt
         * die een oudere toestemming niet noemde (hs_nl, zwangerschapsduur; bij `self` elke groep
         * behalve nl). De aanvulling noemt altijd ALLE keuzes die die tekst toevoegt (groep en
         * zwangerschapsduur), ook als de ouder er nu maar één kiest: dan dekt ze ze ook echt (review
         * gpl-reg r1). Hoort bij dezelfde hash als parental en self.
         */
        extension: {
            title: 'Toestemming voor deze keuzes',
            intro: 'Je gaf al toestemming voor Groei van {name}. De tekst van toen noemde nog niet alles wat je nu kunt kiezen. Daarom vragen we apart toestemming voor deze twee keuzes, ook als je nu maar één ervan kiest:',
            group: 'Een referentiegroep voor de lijnen, zoals Turkse, Marokkaanse of Hindostaanse (Surinaamse) herkomst in Nederland. Die keuze zegt iets over afkomst: dat is een bijzonder persoonsgegeven.',
            gestation: 'De zwangerschapsduur bij de geboorte, als {name} te vroeg geboren is (22 tot en met 36 weken). Dat is een gezondheidsgegeven.',
            rest: 'We gebruiken het alleen voor de lijnen in de grafiek. Alleen de ouders in dit gezin zien het. Niet op de tablet, tenzij een ouder dat zelf per tablet uitdrukkelijk bevestigt; dat kan altijd weer worden weggehaald. Intrekken wist het direct, samen met de metingen. De lijnen zijn geen oordeel of diagnose.\nMet deze toestemming geldt voor {name} de nieuwste tekst van de toestemming voor Groei.',
            check: 'Ik geef toestemming om deze keuzes voor {name} te bewaren.',
            selfText: 'Je ouders kunnen voor jouw groeicurve een referentiegroep kiezen (bijvoorbeeld Turkse, Marokkaanse of Hindostaanse (Surinaamse) herkomst in Nederland). Die zegt iets over afkomst. Ben je te vroeg geboren, dan kunnen ze ook de zwangerschapsduur bij je geboorte invullen: dat is een gezondheidsgegeven. Voor allebei is jouw toestemming nodig.',
            selfCheck: 'Ik geef toestemming om deze keuzes voor mijn eigen groeicurve te bewaren.',
            give: 'Toestemming geven en opslaan',
            giveSelf: 'Toestemming geven',
            needsOwn: '{name} beslist dit zelf: {name} kan het toestaan bij Groei in de eigen app.',
            selfTitle: 'Je toestemming, met de nieuwe tekst',
            extended: 'Aangevuld op {date} met de nieuwste tekst.',
        },
        give: 'Toestemming geven',
        privacyLink: 'Lees de privacyverklaring',
        notNow: 'Niet nu',
        needsOwn: 'Voor {name} kan alleen {name} zelf toestemming geven, met een eigen login.',
        needsOwnTeen: 'Vanaf 16 jaar beslist {name} zelf. Met een eigen login kan {name} bij Groei zelf toestemming geven; daarna kunnen jullie de metingen invullen.',
        lapsed: '{name} is nu 16 en beslist zelf. Je kunt de metingen nog bekijken, downloaden of wissen, maar niet meer aanvullen.',
        given: 'Toestemming gegeven op {date}',
        givenSelf: 'Je gaf zelf toestemming op {date}',
        givenByThem: '{name} gaf zelf toestemming op {date}',
        withdraw: 'Toestemming intrekken en alles wissen',
        withdrawTitle: 'Toestemming intrekken?',
        withdrawBody: 'Alle metingen van {name} worden direct gewist, en ook de keuze voor de groeicurve. Dit kun je niet terugdraaien.',
        withdrawConfirm: 'Intrekken en wissen',
        withdrawn: 'Toestemming ingetrokken. De metingen van {name} zijn gewist.',
    },
    add: 'Meting toevoegen',
    edit: 'Meting wijzigen',
    date: 'Datum',
    length: 'Lengte (cm)',
    weight: 'Gewicht (kg)',
    lengthShort: 'Lengte',
    weightShort: 'Gewicht',
    bmi: 'BMI',
    wflShort: 'Gewicht/lengte',
    note: 'Notitie (mag leeg)',
    notePlaceholder: 'Bijvoorbeeld: gemeten bij de JGZ',
    oneOfBoth: 'Vul lengte, gewicht of allebei in.',
    saved: 'Meting opgeslagen',
    deleted: 'Meting verwijderd',
    deleteConfirm: 'Deze meting verwijderen?',
    errors: {
        empty: 'Vul lengte, gewicht of allebei in.',
        length_range: 'Die lengte klopt niet. Vul hem in centimeters in, bijvoorbeeld 123,5.',
        weight_range: 'Dat gewicht klopt niet. Vul het in kilo in, bijvoorbeeld 24,5.',
        future: 'Die datum ligt in de toekomst.',
        before_birth: 'Die datum ligt vóór de geboortedatum.',
        note_long: 'De notitie is te lang (hooguit 200 tekens).',
        format: 'Gebruik hooguit één cijfer achter de komma.',
    },
    chart: {
        length: 'Lengte naar leeftijd',
        weight: 'Gewicht naar leeftijd',
        bmi: 'BMI naar leeftijd',
        wfl: 'Gewicht naar lengte',
        bmiFrom2: 'BMI tonen we vanaf 2 jaar.',
        age: 'Leeftijd (jaar)',
        date: 'Datum',
        median: 'Midden (gemiddeld)',
        sd1: '−1 en +1 SD',
        sd2: '−2 en +2 SD',
        you: '{name}',
        lastPoint: 'Laatste meting: {value} op {date}',
        info: 'De lijnen zijn een hulpmiddel, geen oordeel of diagnose. Twijfel je, vraag het consultatiebureau of de JGZ.',
        gaps: {
            no_sex: 'Kies hieronder jongen of meisje om de groeilijnen te zien.',
            no_group: 'Kies hieronder een referentiegroep om de groeilijnen te zien. Zonder keuze zie je alleen de metingen.',
            no_birth_date: 'Vul de geboortedatum in om de groei naar leeftijd te zien.',
        },
        source: 'Bron lijnen: {source}',
        /** {cite} staat los (review g3-ux r2): de bron is Latijns en krijgt een eigen <bdi dir="ltr">. */
        sources: {
            schonbeck_2011: 'Nederlandse kinderen, 2009 ({cite})',
            tno_2010: 'Nederlandse kinderen, 2009 ({cite})',
            tno_2010_origin: 'Kinderen van {group} in Nederland, 2009 ({cite})',
            fredriks_2000: 'Nederlandse kinderen, 1997 ({cite})',
            fredriks_2003: 'Kinderen van {group} in Nederland, 1997 ({cite})',
            fredriks_2004: 'Kinderen van {group} in Nederland, 1997 ({cite})',
            de_wilde_2014: 'Kinderen van {group} in Nederland, 2010 ({cite})',
            de_wilde_2013: 'Kinderen van {group} in Nederland, 1976 ({cite})',
            bocca_2012: 'Kinderen geboren na {weeks} weken zwangerschap ({cite})',
            bocca_2012_wfh: 'Kinderen die te vroeg geboren zijn ({cite})',
        },
        citations: {
            schonbeck_2011: 'Schönbeck e.a., PLoS ONE 2011, CC BY',
            tno_2010: 'TNO, Groeidiagrammen 2010',
            tno_2010_origin: 'TNO, Groeidiagrammen 2010',
            fredriks_2000: 'TNO, Fredriks e.a. 2000',
            fredriks_2003: 'TNO, Fredriks e.a. 2003',
            fredriks_2004: 'TNO, Fredriks e.a. 2004',
            de_wilde_2014: 'TNO, de Wilde e.a. 2014',
            de_wilde_2013: 'TNO, de Wilde e.a. 2013',
            bocca_2012: 'TNO, Bocca-Tjeertes e.a. 2012',
            bocca_2012_wfh: 'TNO, Bocca-Tjeertes e.a. 2012',
        },
        /** Golf 19: welke lijnen waar gelden (een tabel per stuk, zie referenceSegments). */
        rangeUntil: 'tot {age} jaar:',
        rangeBetween: '{from} tot {to} jaar:',
        rangeFrom: 'vanaf {age} jaar:',
        sourceJoin: '; ',
        switchNote: 'Bij {age} jaar gaan de lijnen over op een andere tabel (zie de bron hieronder). Daar kunnen ze iets verspringen.',
        pretermNote: 'Tot {age} jaar zie je de lijnen voor kinderen die na {weeks} weken zwangerschap geboren zijn, bij de leeftijd vanaf de geboorte. Daarna de gewone lijnen.',
        pretermWflNote: 'Tot {age} jaar zie je hier de lijnen voor kinderen die te vroeg geboren zijn. Daarna de gewone lijnen.',
        table: 'Tabel met alle metingen',
        showTable: 'Toon als tabel',
        showChart: 'Toon als grafiek',
    },
    settings: {
        title: 'Groeicurve',
        sex: 'Geslacht (voor de groeilijnen)',
        sexUnset: 'Niet gekozen',
        female: 'Meisje',
        male: 'Jongen',
        group: 'Referentiegroep',
        groupHint: 'Alleen voor de lijnen in de grafiek. Kies wat het beste past; je kunt het altijd veranderen of leeg laten.',
        groups: {
            none: 'Geen (alleen metingen)',
            nl: 'Nederlandse kinderen',
            tr_nl: 'Kinderen van Turkse herkomst in Nederland',
            ma_nl: 'Kinderen van Marokkaanse herkomst in Nederland',
            hs_nl: 'Kinderen van Hindostaanse (Surinaamse) herkomst in Nederland',
        },
        groupNames: {
            nl: 'Nederlandse',
            tr_nl: 'Turkse herkomst',
            ma_nl: 'Marokkaanse herkomst',
            hs_nl: 'Hindostaanse (Surinaamse) herkomst',
        },
        /** Golf 19: neutrale uitleg bij de groepen en de zwangerschapsduur (alleen te vroeg). */
        groupInfo: 'De lijnen per groep komen uit Nederlands onderzoek bij kinderen van die herkomst. Hindostaans (Surinaams) gaat over kinderen met Zuid-Aziatische voorouders, vaak via Suriname. Niet elke groep heeft voor elke maat eigen lijnen; onder de grafiek staat welke lijnen je ziet.',
        gestation: 'Zwangerschapsduur bij de geboorte',
        gestationNone: 'Op tijd geboren (of niet ingevuld)',
        gestationWeeks: '{weeks} weken',
        gestationHint: 'Alleen invullen als {name} te vroeg geboren is (vóór {term} weken). Tot {age} jaar zie je dan de lijnen voor te vroeg geboren kinderen; bij {min} tot {max} weken zijn dat de lijnen van {table} weken. Dit is een gezondheidsgegeven: het valt onder dezelfde toestemming als de metingen, alleen ouders zien het en intrekken wist het ook.',
        saved: 'Opgeslagen',
    },
    birthDate: 'Geboortedatum van {name}',
    birthDateHint: 'Nodig voor de groei naar leeftijd. Staat ook bij Verjaardagen.',
    download: 'Downloaden',
    downloadCsv: 'Als tabel (CSV)',
    downloadJson: 'Alles (JSON)',
    clear: 'Alle metingen wissen',
    clearTitle: 'Alle metingen van {name} wissen?',
    clearBody: 'De toestemming blijft staan, zodat je opnieuw kunt beginnen. Dit kun je niet terugdraaien.',
    cleared: 'Alle metingen van {name} zijn gewist.',
    privacyNote: 'Alleen ouders zien dit. Niet op de tablet, tenzij een ouder dat zelf per tablet uitdrukkelijk bevestigt; dat kan altijd weer worden weggehaald.',
    selfIntro: 'Jouw lengte en gewicht, rustig in een groeicurve. Je ouders vullen de metingen in; alleen jij en je ouders zien dit.',
    selfUnder16: 'Je ouders houden je lengte en gewicht bij. Vanaf 16 jaar beslis je dat zelf.',
    selfNote: 'Alleen jij en je ouders zien dit. Niet op de tablet, tenzij een ouder dat zelf per tablet uitdrukkelijk bevestigt; dat kan altijd weer worden weggehaald.',
    /** Kolomkoppen van de CSV-download (review g3-fs r1: in de taal van het gezin). */
    csvHead: ['datum', 'lengte_cm', 'gewicht_kg', 'bmi', 'notitie'],
    moduleOff: 'Groei hoort bij de module Gezondheid. Die staat uit.',
};
export const appSchoolNl = {
    title: 'School',
    intro: 'Rapportcijfers en toetsen per kind, rustig op een tijdlijn. Alleen ouders zien dit; nooit op de tablet.',
    childIntro: 'Jouw rapporten en toetsen. Je ouders vullen dit in.',
    childOff: 'Je ouders hebben dit nog niet voor je aangezet.',
    tab: 'School',
    open: 'School van {name}',
    noChildren: 'Er staan nog geen kinderen in jullie gezin.',
    empty: 'Nog niets ingevuld. Begin met het laatste rapport of een toets.',
    nothingYet: 'Nog niets ingevuld',
    count: '{count} resultaten',
    countOne: '1 resultaat',
    add: 'Resultaat toevoegen',
    edit: 'Resultaat wijzigen',
    saved: 'Opgeslagen',
    deleted: 'Verwijderd',
    deleteConfirm: 'Dit resultaat verwijderen?',
    timeline: 'Tijdlijn',
    trends: 'Per vak',
    noTrend: 'Een lijn verschijnt als er twee of meer resultaten zijn.',
    childView: 'Mag {name} dit zelf zien?',
    childViewHint: 'Alleen met een eigen login in de webapp, alleen het eigen resultaat en alleen lezen. Nooit op de tablet.',
    childViewOn: '{name} kan dit nu zelf zien.',
    childViewOff: '{name} ziet dit niet.',
    download: 'Downloaden',
    downloadCsv: 'Als tabel (CSV)',
    downloadJson: 'Alles (JSON)',
    clear: 'Alles van {name} wissen',
    clearTitle: 'Alle resultaten van {name} wissen?',
    clearBody: 'Dit kun je niet terugdraaien.',
    cleared: 'Alle resultaten van {name} zijn gewist.',
    field: {
        kind: 'Soort',
        schoolYear: 'Schooljaar',
        period: 'Moment',
        date: 'Datum (mag leeg)',
        group: 'Groep',
        groupNone: 'Onbekend',
        subject: 'Vak',
        domain: 'Onderdeel',
        scale: 'Schaal',
        grade: 'Cijfer',
        gradeHint: 'Van 1 tot 10, bijvoorbeeld 7,5',
        word: 'Beoordeling',
        level: 'Niveau',
        score: 'Vaardigheidsscore (mag leeg)',
        dmtScore: 'Score (aantal woorden goed)',
        provider: 'Toets van (mag leeg)',
        note: 'Notitie (mag leeg)',
    },
    errors: {
        school_year: 'Kies een schooljaar.',
        period: 'Kies een moment dat bij deze soort past.',
        group: 'Kies een groep van 1 tot 8.',
        subject: 'Kies een vak.',
        domain: 'Kies een onderdeel.',
        scale: 'Kies een schaal.',
        value: 'Deze waarde past niet bij de schaal.',
        provider: 'Kies een toets uit de lijst.',
        note: 'De notitie is te lang (hooguit 200 tekens).',
        future: 'Die datum ligt in de toekomst.',
        subject_dup: 'Dit vak staat er al.',
    },
    /** Titels van een lijn "Per vak" (review g3-ux r1): rapport en toets nooit dezelfde titel. */
    titles: {
        grade: '{subject} · rapport',
        lvs: 'Toets · {domain}',
    },
    kinds: {
        grade: 'Rapportcijfer',
        lvs: 'Toets (leerlingvolgsysteem)',
        avi: 'AVI-leesniveau',
        dmt: 'DMT (Drie-Minuten-Toets)',
        level: 'Functioneringsniveau',
        doorstroom: 'Doorstroomtoets groep 8',
        advies: 'Schooladvies',
    },
    periods: {
        b: 'Begin',
        r1: 'Rapport 1',
        m: 'Midden',
        r2: 'Rapport 2',
        r3: 'Rapport 3',
        e: 'Eind',
        r4: 'Rapport 4',
        voorlopig: 'Voorlopig',
        definitief: 'Definitief',
    },
    /** Kort, voor de x-as van een trendlijn ("24/25 R1"). */
    periodsShort: {
        b: 'B',
        r1: 'R1',
        m: 'M',
        r2: 'R2',
        r3: 'R3',
        e: 'E',
        r4: 'R4',
        voorlopig: 'voorl.',
        definitief: 'def.',
    },
    scales: {
        number: 'Cijfer 1-10',
        word: 'Woorden (O t/m ZG)',
        roman: 'I t/m V',
        letter: 'A t/m E',
        ref: '1F / 2F / 1S',
    },
    domains: {
        rekenen: 'Rekenen',
        begrijpend_lezen: 'Begrijpend lezen',
        spelling: 'Spelling',
        technisch_lezen: 'Technisch lezen',
        lezen: 'Lezen',
        taalverzorging: 'Taalverzorging',
    },
    providers: {
        cito: 'Cito (Leerling in beeld)',
        boom: 'Boom LVS',
        iep: 'IEP',
        dia: 'Diatoetsen',
        amn: 'AMN',
        route8: 'ROUTE 8',
        doe: 'DOE-toets',
        other: 'Anders',
    },
    words: {
        O: 'Onvoldoende',
        M: 'Matig',
        V: 'Voldoende',
        RV: 'Ruim voldoende',
        G: 'Goed',
        ZG: 'Zeer goed',
    },
    advice: {
        pro: 'Praktijkonderwijs',
        vmbo_b: 'vmbo basis',
        vmbo_b_k: 'vmbo basis / kader',
        vmbo_k: 'vmbo kader',
        vmbo_k_gt: 'vmbo kader / gt',
        vmbo_gt: 'vmbo gemengd/theoretisch (gt)',
        vmbo_gt_havo: 'vmbo gt / havo',
        havo: 'havo',
        havo_vwo: 'havo / vwo',
        vwo: 'vwo',
    },
    /** Eén vriendelijke uitlegregel per maat ("AVI E5 = het leesniveau van eind groep 5"). */
    explain: {
        grade: 'Een rapportcijfer van 1 tot 10. Een 5,5 of hoger is voldoende.',
        word: '{code} = {word}.',
        aviStart: 'AVI-Start = het begin van het leren lezen, in groep 3.',
        aviPlus: 'AVI-Plus = het hoogste AVI-niveau, na eind groep 7.',
        avi: 'AVI {code} = het leesniveau van {moment} groep {group}.',
        level: '{code} = het niveau van {moment} groep {group}.',
        roman: {
            I: 'I = bij de hoogste 20% van de kinderen in Nederland.',
            II: 'II = net boven het gemiddelde (de volgende 20%).',
            III: 'III = rond het gemiddelde (de middelste 20%).',
            IV: 'IV = net onder het gemiddelde (de volgende 20%).',
            V: 'V = bij de laagste 20%. De school kijkt dan wat extra helpt.',
        },
        letter: {
            A: 'A = bij de hoogste 25% van de kinderen in Nederland.',
            B: 'B = net boven het gemiddelde (de volgende 25%).',
            C: 'C = net onder het gemiddelde (de volgende 25%).',
            D: 'D = ruim onder het gemiddelde (de volgende 15%).',
            E: 'E = bij de laagste 10%. De school kijkt dan wat extra helpt.',
        },
        ref: {
            '<1F': '1F nog niet gehaald. Dat is het basisniveau voor eind groep 8.',
            '1F': '1F = het basisniveau dat bijna alle kinderen eind groep 8 halen.',
            '2F': '2F = het streefniveau voor lezen en taal eind groep 8.',
            '1S': '1S = het streefniveau voor rekenen eind groep 8.',
        },
        dmt: 'De DMT meet hoeveel losse woorden een kind in drie minuten goed leest.',
        doorstroom: 'De doorstroomtoets (sinds 2024) meet lezen, taalverzorging en rekenen in 1F, 2F en 1S.',
        advies: 'Het schooladvies zegt welk type voortgezet onderwijs past.',
        moments: { B: 'begin', M: 'midden', E: 'eind' },
    },
    subjects: {
        title: 'Vakken',
        hint: 'De vakken op het rapport van jullie school. Je kunt ze hernoemen of weghalen; oude cijfers blijven staan.',
        add: 'Vak toevoegen',
        name: 'Naam van het vak',
        suggested: 'Standaardvakken toevoegen',
        suggestions: [
            'Rekenen',
            'Taal',
            'Spelling',
            'Lezen',
            'Begrijpend lezen',
            'Schrijven',
            'Aardrijkskunde',
            'Geschiedenis',
            'Natuur',
            'Engels',
        ],
        remove: 'Weghalen',
        rename: 'Hernoemen',
        removed: 'Vak weggehaald. Oude cijfers blijven staan.',
        none: 'Nog geen vakken. Voeg ze toe of kies de standaardvakken.',
        archived: '{name} (weggehaald)',
    },
    /** Kolomkoppen van de CSV-download (review g3-fs r1: in de taal van het gezin). */
    csvHead: [
        'schooljaar',
        'periode',
        'datum',
        'groep',
        'soort',
        'vak_of_domein',
        'waarde',
        'toets',
        'notitie',
    ],
    moduleOff: 'School staat uit.',
};
//# sourceMappingURL=groeiSchoolApp.nl.js.map